import HistoricalIndexWidget from './widget'
import {
  useGetHistoryIndexSitesQuery,
  useLazyGetHistoryIndexChartQuery,
} from '../../../store/api'
import Mixpanel from '../../../utils/mixpanel/Mixpanel'

export default function HistoricalIndexChart() {
  const { data: sites, isSuccess: isSitesLoaded } =
    useGetHistoryIndexSitesQuery({})
  const [
    getChartData,
    { data, currentData, isLoading, isFetching, isSuccess },
  ] = useLazyGetHistoryIndexChartQuery()

  return (
    <div className="mb-8">
      <HistoricalIndexWidget
        sites={sites}
        isSitesLoaded={isSitesLoaded}
        chartData={currentData ?? data}
        isLoading={isLoading}
        isFetching={isFetching}
        isSuccess={isSuccess}
        onFilterChange={({ siteIds, startAt, endAt }) =>
          getChartData({ siteIds, startAt, endAt })
        }
        onTabClick={(event) =>
          Mixpanel.track(event, {
            page: 'Dashboard',
            section: 'Historical Index Chart',
          })
        }
      />
    </div>
  )
}
